module.exports = __webpack_public_path__ + "static/media/slide_7.4224e120.jpg";